export const appId = 'shopline'
export const appVer = '3.4'
export const traceState = `appid=${appId},appver=${appVer}`

/** 默认概率 0 */
const chance = process.env.NODE_ENV === 'production' ? 0.5 : 0

/**
 * 生成 traceParent
 * 主要用于 trace 上报
 */
export function genTraceParent() {
  const arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f']
  const version = '00'
  /** 上报抽样 01 否则 00 */
  // const traceFlag = '01'

  let traceId = ''
  let parentId = ''
  let count = 0

  while (count < 32) {
    // 16位 十六进制字符串
    if (count < 16) {
      parentId += arr[Math.floor(Math.random() * 16)]
    }

    // 32位 十六进制字符串
    traceId += arr[Math.floor(Math.random() * 16)]
    count++
  }

  return `${version}-${traceId}-${parentId}`
}

/**
 * trace上报
 * header中增加 traceParent 和 traceState
 * 配置中记录traceInfo response拦截上报数据使用
 */
export function setTraceInfo(options: any) {
  const hit = Math.random() < chance
  const traceFlag = hit ? '01' : '00'
  const traceParent = `${genTraceParent()}-${traceFlag}`

  options.traceInfo = {
    traceStart: Date.now(),
    traceParent,
  }

  options.headers = Object.assign(options.headers, { traceparent: traceParent, tracestate: traceState })
}
